export const TableDragHandle = () => (
  <div
    style={{
      display: 'flex',
      width: '48px',
      height: '48px',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'grab',
      userSelect: 'none',
    }}
  >
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 0.75L11.25 2L0.75 2L0.75 0.75L11.25 0.75ZM11.25 7.125L11.25 6.125C11.25 6.05625 11.1937 6 11.125 6L0.875 6C0.806249 6 0.75 6.05625 0.75 6.125L0.75 7.125C0.75 7.19375 0.806249 7.25 0.875 7.25L11.125 7.25C11.1937 7.25 11.25 7.19375 11.25 7.125Z"
        fill="black"
        fillOpacity="0.45"
      />
    </svg>
  </div>
)
